import { money } from '@/lib/homepage/format';

// "or £225 cash alternative", "OR £1,500 CASH", "- or £50 cash alt": the cash
// alternative written into a title, with whatever joins it to the prize.
const IN_TITLE = /\s*[-–—,:(]?\s*\bor\s+£\s?([\d,]+(?:\.\d{1,2})?)\s+cash(?:\s+alt(?:ernative)?)?\b\)?/i;

/** True when the title has the cash alternative written into it. */
export const titleHasCashAlternative = (title) => IN_TITLE.test(String(title || ''));

/**
 * The title to show big, and the cash alternative line to show under it.
 * Players see a cash alternative only when the builder's "Offer a cash
 * alternative" box is ticked (Rob); cash prizes never have one. Its amount
 * is the competition's cash alternative, never the prize value (they are
 * different things). A cash alternative written into the title always comes
 * out of it: shown as the line when ticked, not at all when not.
 */
export function splitCashAlternative(c) {
  const full = String(c?.title || '').trim();
  const m = full.match(IN_TITLE);
  const title = (m ? full.replace(IN_TITLE, '').replace(/\s+([!?.])/g, '$1').trim() : full) || full;
  const offered = Boolean(c?.showCashAlternative) && c?.category !== 'cash';
  if (!offered) return { title, cashLine: null };
  const amount = Number(c?.cashAlternative) || (m ? Number(m[1].replace(/,/g, '')) : 0);
  return {
    title,
    cashLine: amount > 0 ? `Or ${money(amount)} cash alternative` : null,
  };
}
